<div class="order-drawer">
  <button
    type="button"
    class="drawer-close-btn"
    (click)="closeDescription()"
    aria-label="Close order details"
  >
    <i class="bx bx-x"></i>
  </button>
  <div class="drawer-top">
    <div class="drawer-header">
      <div class="table-badge">
        <span>{{ getOrderTableLabel() | titlecase }}</span>
      </div>
      <div class="order-meta">
        <div class="customer-name">{{ selectedOrder.customers[0].first_name }}</div>
        <div class="order-number">{{ selectedOrder.order_number }}</div>
      </div>
      <div class="status-col">
        <div class="status-badge" [ngClass]="getStatusVariant()">
          <span class="status-icon-wrap">
            <i
              class="bx status-icon"
              [ngClass]="{
                'bx-basket': getStatusVariant() === 'in-progress',
                'bx-check-double':
                  getStatusVariant() === 'placed' || getStatusVariant() === 'completed',
                'bx-x-circle': getStatusVariant() === 'cancelled',
              }"
            ></i>
          </span>
          <span class="status-text">{{ selectedOrder.displayStatus }}</span>
        </div>
      </div>
    </div>

    <div class="divider-line"></div>

    <div class="waiter-profiles-row">
      <div class="waiter-section">
        @if (selectedOrder.order_type == 'togo' || selectedOrder.order_type == 'online') {
          <div class="order-time">{{ displayCreateddate(selectedOrder.created_at) }}</div>
        } @else {
          @if (selectedOrder.served_by?.img_path?.trim()) {
            <img
              class="avatar waiter-avatar"
              [src]="selectedOrder.served_by.img_path"
              (error)="onServedByImageError($event)"
            />
          } @else if (selectedOrder.served_by?.first_name) {
            <span class="avatar-name">{{
              getFirstLetterOfString(selectedOrder.served_by?.first_name)
            }}</span>
          } @else {
            <img class="avatar waiter-avatar" src="assets/default/profile.png" />
          }
          <div class="waiter-text">
            <span class="order-time">{{ displayCreateddate(selectedOrder.created_at) }}</span>
            <div class="d-flex gap-1">
              <span class="served-by-label">Served by:</span>
              <span class="waiter-name">{{
                selectedOrder.served_by?.first_name ? selectedOrder.served_by?.first_name : 'N/A'
              }}</span>
            </div>
          </div>
        }
      </div>
      <div class="profiles-actions">
        <div class="avatar-stack">
          @for (customer of selectedOrder.customers; track customer; let c = $index) {
            <div
              [matTooltip]="customer.first_name"
              class="avatar-circle avatar-20 stack-item"
              [style.z-index]="selectedOrder.customers.length - c"
            >
              @if (hasCustomerImage(customer)) {
                <img
                  class="customer-avatar"
                  [src]="customer.img_path.trim()"
                  [alt]="customer.first_name"
                  loading="lazy"
                  (error)="onCustomerImageError(customer)"
                />
              } @else {
                <span
                  [style.background-color]="getRgbaColor(customer.configs?.color_code, 0.2)"
                  [style.color]="customer.configs?.color_code"
                  class="customer-avatar"
                >
                  {{ getFirstLetterOfString(customer.first_name) }}
                </span>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  <div class="drawer-body">
    <div class="order-items-list">
      @if (selectedOrder.menu_items.length == 0) {
        <div class="empty-state-wrap">
          <div class="empty-state">
            <img class="image" src="./../../../../assets/empty-menu.png" />
            <div class="the-cart-is-empty">The cart is empty!</div>
          </div>
        </div>
      } @else {
        @for (itemGroup of groupByCustomerList | keyvalue; track itemGroup) {
          <div class="customer-group-label">
            @if (this.selectedOrder.order_type == 'togo') {
              {{ selectedOrder.customers[0].first_name }}
            } @else {
              {{ getCustomerName(itemGroup.key) }}
            }
          </div>

          @for (item of itemGroup.value; track item; let mi = $index) {
            <div class="dish-row">
              <div class="dish-toggle">
                <a
                  class="app-menu-arrow collapsed"
                  data-bs-toggle="collapse"
                  [href]="'#' + item.item_id"
                  role="button"
                  aria-expanded="false"
                >
                  <i class="bx bx-chevron-right"></i>
                </a>
              </div>
              <div class="dish-image-wrap">
                <img
                  class="dish-img"
                  [class.image-error]="hasImageError(item.item_id)"
                  [src]="item.thumbnail_url"
                  (error)="onMenuThumbnailImageError($event, item.item_id)"
                />
              </div>
              <div class="dish-info">
                <div class="dish-name" matTooltip="{{ item.name }}">
                  {{ truncateString(item.name, 40) }}
                </div>
                <div class="dish-desc" matTooltip="{{ item.description }}">
                  {{ truncateString(item.description, 55) }}
                </div>
              </div>
              <div class="dish-qty"><span class="qty-unit">x </span>{{ item.quantity }}</div>
              <div class="dish-price">
                <span class="price-currency">$</span>{{ item.total | number: '1.2-2' }}
              </div>
            </div>

            <div class="collapse" [id]="item.item_id">
              @if (item.variation?.customizations?.length == 0 || !item.variation) {
                <p class="text-muted text-center empty-customization">No more customizations</p>
              } @else if (item.variation?.customizations?.length > 0) {
                <div class="addons-row">
                  @for (customization of item.variation.customizations; track customization) {
                    <span class="addon-chip">
                      <span class="addon-key">{{ customization.name }}: </span>
                      @if (customization.selected_type?.length > 0) {
                        @for (
                          customizationType of customization.selected_type;
                          track customizationType;
                          let cti = $index
                        ) {
                          <span
                            >{{ customizationType?.value }} (+${{
                              customizationType?.price | number: '1.2-2'
                            }})
                            @if (cti < customization.selected_type.length - 1) {
                              ,
                            }
                          </span>
                        }
                      } @else if (customization.selected_type) {
                        <span
                          >{{ customization.selected_type?.value }} (+${{
                            customization.selected_type?.price | number: '1.2-2'
                          }})</span
                        >
                      }
                    </span>
                  }
                </div>
              }

              @if (item.variation?.customer_notes && item.variation?.customer_notes != '') {
                <div class="addons-row">
                  <span class="cx-note-chip">
                    <i class="bx bx-note"></i>
                    <span matTooltip="{{ item.variation?.customer_notes }}">{{
                      truncateString(item.variation?.customer_notes, 70)
                    }}</span>
                  </span>
                </div>
              }
            </div>

            @if (mi < itemGroup.value.length - 1) {
              <div class="divider-line dish-divider"></div>
            }
          }
        }
      }
    </div>
    @if (selectedOrder?.note && selectedOrder?.note != '') {
      <div class="order-notes">
        <div class="order-note-card">
          <div class="order-note-icon-wrap">
            <i class="bx bx-detail order-note-icon"></i>
          </div>
          <p class="order-note-text">
            {{ selectedOrder?.note }}
          </p>
        </div>
      </div>
    }
  </div>

  <div class="drawer-bottom">
    <div class="action-btn-row">
      @if (selectedOrder?.payment_method?.payments?.length > 0) {
        <a class="action-pill" (click)="openPaymentSummary()">
          <i class="bx bx-credit-card action-pill-icon"></i>
          <span>View Payment Details</span>
        </a>
      }
      <a class="action-pill" (click)="openFeedback()">
        <i class="bx bx-message-square-detail action-pill-icon"></i>
        <span>View Feedback</span>
      </a>
    </div>
    <div class="bill-summary">
      <div class="bill-row">
        <span class="bill-label">Sub Total</span>
        <span class="bill-value" [ngClass]="{ 'text-light-80': selectedOrder.sub_total == 0 }">
          <span class="bill-currency">$</span>{{ selectedOrder.sub_total | number: '1.2-2' }}
        </span>
      </div>
      <div class="bill-row">
        <span class="bill-label">Discount</span>
        <span
          class="bill-value"
          [ngClass]="{
            'text-light-80': selectedOrder.discount == 0,
            'bill-value-discount': selectedOrder.discount > 0,
          }"
        >
          <span class="bill-currency">$</span>{{ selectedOrder.discount | number: '1.2-2' }}
        </span>
      </div>
      <div class="bill-row">
        <span class="bill-label">Tax ({{ selectedOrder.tax_percentage }}%)</span>
        <span class="bill-value" [ngClass]="{ 'text-light-80': selectedOrder.tax_amount == 0 }">
          <span class="bill-currency">$</span>{{ selectedOrder.tax_amount | number: '1.2-2' }}
        </span>
      </div>
      <div class="bill-row">
        <span class="bill-label">Tip</span>
        <span class="bill-value" [ngClass]="{ 'text-light-80': selectedOrder.tip_amount == 0 }">
          <span class="bill-currency">$</span>{{ selectedOrder.tip_amount | number: '1.2-2' }}
        </span>
      </div>
    </div>

    <div class="divider-line"></div>

    <div class="bill-row">
      <span class="bill-label">Total Paid</span>
      <span class="bill-value" [ngClass]="{ 'text-light-80': selectedOrder.total == 0 }">
        <span class="bill-currency">$</span>{{ selectedOrder.total | number: '1.2-2' }}
      </span>
    </div>
    <div class="bill-row">
      <span class="bill-label">Refund</span>
      <span
        class="bill-value"
        [ngClass]="{
          'text-light-80': selectedOrder.total_refund == 0,
          'bill-value-refund': selectedOrder.total_refund > 0,
        }"
      >
        <span class="bill-currency">$</span>{{ selectedOrder.total_refund | number: '1.2-2' }}
      </span>
    </div>
    <div class="divider-line"></div>
    <div class="total-row">
      <span class="total-label">NET TOTAL</span>
      <span class="total-amount"
        ><span class="total-currency">$</span
        >{{ selectedOrder.total_after_refund | number: '1.2-2' }}</span
      >
    </div>
  </div>
</div>
